(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters-sidebar"] && !Shopify.designMode) return;
  try {
    for( const btn of document.querySelectorAll(".sidebar__heading.js") ) {
    btn.addEventListener("click", function () {
        const accordionBody = this.closest(".sidebar__filter__group");
        if( accordionBody.classList.contains("closed") ) {
            accordionBody.classList.remove("closed");
        } else {
            accordionBody.classList.add("closed");
        }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
